<div class=p404>
  <div class="number">404</div>
  <div class="text">Страница не найдена</div>
  <br>
  <div class="text"><a routerLink="/">На главную</a></div>
  <div class="copyright">© <a href="https://vk.com/album-1214645_269424453">Туристский клуб "Алмасты"</a> - Архангельск,
    Пинега 19/20
  </div>
</div>
